import {AccountMin} from "platformed-client/types";
import {platformedClient} from "../index";

export async function listAccounts(): Promise<AccountMin[]> {
  return await platformedClient.internalRequest("get", "/api/internal/accounts", {});
}
